import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import { CartProvider } from "./context/CartContext";
import { UserAuthProvider } from "./context/UserAuthContext";
import { SearchProvider } from "./context/SearchContext";
import { Toaster } from "react-hot-toast";
import { LoadingProvider } from "./context/LoadingContext";
import { ProductProvider } from "./context/ProductContext";
import { CouponProvider } from "./context/CouponContext";
import { WarmupProvider } from "./context/WarmupContext";
import { HelmetProvider } from "react-helmet-async";
import { initPostHog } from "./analytics/posthog";

initPostHog();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <HelmetProvider>
      <SearchProvider>
        <AdminAuthProvider>
          <AuthProvider>
            <UserAuthProvider>
              <GoogleOAuthProvider
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
              >
                <CartProvider>
                  <Toaster
                    position="top-right"
                    toastOptions={{
                      duration: 4000,
                      style: {
                        background: "#1f2937", // Tailwind gray-800
                        color: "#fff",
                        borderRadius: "8px",
                        padding: "12px 16px",
                      },
                      success: {
                        style: {
                          background: "#16a34a", // Tailwind green-600
                        },
                      },
                      error: {
                        style: {
                          background: "#dc2626", // Tailwind red-600
                        },
                      },
                      loading: {
                        style: {
                          background: "#0ea5e9", // Tailwind sky-500
                        },
                      },
                    }}
                  />
                  <LoadingProvider>
                    <WarmupProvider>
                      <ProductProvider>
                        <CouponProvider>
                          <App />
                        </CouponProvider>
                      </ProductProvider>
                    </WarmupProvider>
                  </LoadingProvider>
                </CartProvider>
              </GoogleOAuthProvider>
            </UserAuthProvider>
          </AuthProvider>
        </AdminAuthProvider>
      </SearchProvider>
    </HelmetProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
